import { render, staticRenderFns } from "./FlowCmptTabs.vue?vue&type=template&id=1b37402c&"
import script from "./FlowCmptTabs.vue?vue&type=script&lang=js&"
export * from "./FlowCmptTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports